export default [
  {
    address: "0x62B9c7356A2Dc64a1969e19C23e4f579F9810Aa7",
    symbol: "cvxCRV",
  },
  {
    address: "0x4e3FBD56CD56c3e72c1403e103b45Db9da5B9D2B",
    symbol: "CVX",
  },
] as const
